module.exports = __webpack_public_path__ + "img/Strawberry Parfait Ice Cream.e6bea1a8.png";